import { toast } from "react-toastify";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import I18n from "../i18n/I18n";
import Helper from "../helper/Helper";
import { put, call, takeLatest } from "redux-saga/effects";

/* eslint-disable camelcase */

export default api => {
  /********************************************
    Get User Details
    ********************************************/
  function* getUser(action) {
    const response = yield call(api.user.getUser);
    if (response && response.data && response.data.data) {
      window.location.replace(
        `${Helper.getSubdomain("core")}${Helper.getUrlLocale()}/`
      );

      yield put(
        Actions.getUserSuccess({
          ...response.data.data
        })
      );
      yield put(Actions.getSeller());

      // Set AppUser object in window so Zendesk chat client can read it.
      window.AppUser = Object.assign({}, response.data.data);
    } else {
      yield put(Actions.getUserFailure());
    }
  }

  function* watchGetUser() {
    yield takeLatest(Types.GET_USER, getUser);
  }

  /********************************************
    Get Seller Details
    ********************************************/
  function* getSeller(action) {
    const response = yield call(api.user.getSeller);
    if (response && response.data && response.data.data) {
      yield put(
        Actions.getSellerSuccess(
          response.data.data,
          response.data.is_noon_user,
          response.data.partner_countries,
          response.data.partner_menu
        )
      );
      if (
        response.data.data.is_allow_fbn_asn ||
        response.data.data.force_is_fbn_eligible
      )
        yield put(Actions.syncInventory());
      const query = "is_read=0";
      yield put(Actions.getNotification(query));

      // Set AppUser object in window so Zendesk chat client can read it.
      //window.AppUser = Object.assign({}, response.data.data);
    } else {
      yield put(Actions.getSellerFailure());
    }
  }

  function* watchGetSeller() {
    yield takeLatest(Types.GET_USER, getUser);
    yield takeLatest(Types.GET_SELLER, getSeller);
  }

  /********************************************
Logout
********************************************/
  function* logout() {
    try {
      const response = yield call(api.user.logout);
      if (response && response.status === 200) {
        yield put(Actions.logoutSuccess());
      } else {
        yield put(Actions.logoutFailure());
      }
    } catch (e) {
      return;
    }
  }

  function* watchLogout() {
    yield takeLatest(Types.LOGOUT, logout);
  }

  /********************************************
  Get Seller Details
  ********************************************/
  function* acceptTerms(action) {
    const response = yield call(api.user.acceptTerms);
    if (response && response.data && response.data.data) {
      yield put(
        Actions.acceptTermsSuccess({
          ...response.data.data
        })
      );

      // Set AppUser object in window so Zendesk chat client can read it.
      //window.AppUser = Object.assign({}, response.data.data);
    } else {
      yield put(Actions.acceptTermsFailure());
    }
  }

  function* watchAcceptTerms() {
    yield takeLatest(Types.ACCEPT_TERMS, acceptTerms);
  }

  function* getTnC(action) {
    try {
      const response = yield call(api.user.getTnC, action.country);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getTnCSuccess(response.data));
      } else {
        yield put(Actions.getTnCFailure(response.data.error));
        // toast(response.data.error || "Error", {
        //   type: "error",
        //   className: "errorClass"
        // });
      }
    } catch (error) {
      yield put(Actions.getTnCFailure(error));
    }
  }

  function* watchGetTnC(): Generator<void, void, void> {
    yield takeLatest(Types.GET_TNC, getTnC);
  }

  /********************************************
  Get WareHouses Details
  ********************************************/

  function* getWareHouses(action) {
    try {
      const response = yield call(api.user.getWareHouses, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getWareHousesSuccess(response.data));
      } else {
        yield put(Actions.getWareHousesFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getWareHousesFailure(error));
    }
  }

  function* watchGetWareHouses(): Generator<void, void, void> {
    yield takeLatest(Types.GET_WAREHOUSES, getWareHouses);
  }

  /********************************************
  Get Vat Details
  ********************************************/

  function* getVatInfo(action) {
    try {
      const response = yield call(api.user.getVatInfo);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getVatInfoSuccess(response.data));
      } else {
        yield put(Actions.getVatInfoFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getVatInfoFailure(error));
    }
  }

  function* watchGetVatInfo(): Generator<void, void, void> {
    yield takeLatest(Types.GET_VAT_INFO, getVatInfo);
  }

  /********************************************
  Get users list
  ********************************************/

  function* getUsersList(action) {
    try {
      const response = yield call(api.user.getUsersList);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getUsersListSuccess(response.data));
      } else {
        yield put(Actions.getUsersListFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getUsersListFailure(error));
    }
  }

  function* watchGetUsersList(): Generator<void, void, void> {
    yield takeLatest(Types.GET_USERS_LIST, getUsersList);
  }

  /********************************************
  Get notification Preference
  ********************************************/

  function* getNotificationPreference(action) {
    try {
      const response = yield call(api.user.getNotificationPreference);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getNotificationPreferenceSuccess(response.data));
      } else {
        yield put(
          Actions.getNotificationPreferenceFailure(
            response.data.error || "Error"
          )
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getNotificationPreferenceFailure(error));
    }
  }

  function* watchGetNotificationPreference(): Generator<void, void, void> {
    yield takeLatest(
      Types.GET_NOTIFICATION_PREFERENCE,
      getNotificationPreference
    );
  }

  /********************************************
  Post Preference
  ********************************************/

  function* postPreference(action) {
    try {
      const response = yield call(api.user.postPreference, action.pref);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.postPreferenceSuccess(response.data));
        yield put(Actions.getWareHouses());
        toast(
          I18n.getText(
            "settings.update-preference",
            {},
            "Preference Updated Successfully"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.postPreferenceFailure(response.data.error));
        toast(
          response.data.error ||
            I18n.getText(
              "settings.update-error",
              {},
              "Couldn't Update Preference"
            ),
          {
            type: "error",
            className: "errorClass"
          }
        );
      }
    } catch (error) {
      yield put(Actions.postPreferenceFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }

  function* watchPostPreference(): Generator<void, void, void> {
    yield takeLatest(Types.POST_PREFERENCE, postPreference);
  }

  /********************************************
<<<<<<< HEAD
    Get Notification Details
    ********************************************/
  function* getNotification(action) {
    try {
      const response = yield call(api.user.getNotification, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getNotificationSuccess(response.data));
      } else {
        yield put(Actions.getNotificationFailure());
        // toast(response.data.error || "Error", {
        //   type: "error",
        //   className: "errorClass"
        // });
      }
    } catch (error) {
      yield put(Actions.getNotificationFailure());
    }
  }

  function* watchGetNotification() {
    yield takeLatest(Types.GET_NOTIFICATION, getNotification);
  }

  /********************************************
    Get Notification Details
    ********************************************/
  function* readNotification(action) {
    try {
      const response = yield call(api.user.readNotification, action.notObj);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.readNotificationSuccess());
        const query = "is_read=0";
        yield put(Actions.getNotification(query));
      } else {
        yield put(Actions.readNotificationFailure());
      }
    } catch (error) {
      yield put(Actions.readNotificationFailure());
    }
  }

  function* watchReadNotification() {
    yield takeLatest(Types.READ_NOTIFICATION, readNotification);
  }

  /**

Get users list
********************************************/

  function* getOfferCount(action) {
    try {
      const response = yield call(api.user.getOfferCount);
      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getOfferCountSuccess(response.data));
      } else {
        yield put(Actions.getOfferCountFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getOfferCountFailure(error));
    }
  }

  function* watchGetOfferCount(): Generator<void, void, void> {
    yield takeLatest(Types.GET_OFFER_COUNT, getOfferCount);
  }

  /****

    Sync Inventory
  ********************************************/

  function* syncInventory(action) {
    try {
      const response = yield call(api.user.syncInventory);
      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.syncInventorySuccess());
      } else {
        yield put(Actions.syncInventoryFailure());
      }
    } catch (error) {
      yield put(Actions.syncInventory());
    }
  }

  function* watchSyncInventory(): Generator<void, void, void> {
    yield takeLatest(Types.SYNC_INVENTORY, syncInventory);
  }

  /********************************************
  Get FBN Settings
  ********************************************/

  function* getFbnSettings(action) {
    try {
      const response = yield call(api.user.getFbnSettings);
      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getFbnSettingsSuccess(response.data));
      } else {
        yield put(
          Actions.getFbnSettingsFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getFbnSettingsFailure(error));
    }
  }

  function* watchGetFbnSettings(): Generator<void, void, void> {
    yield takeLatest(Types.GET_FBN_SETTINGS, getFbnSettings);
  }

  /********************************************
  Change Fbn
  ********************************************/

  function* changeFbnSettings(action) {
    try {
      const response = yield call(api.user.postFbnSettings, action.setting);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.changeFbnSettingsSuccess(response.data));
        toast(
          I18n.getText(
            "settings.update-preference",
            {},
            "Preference Updated Successfully"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.changeFbnSettingsFailure(response.data.error));
        toast(
          response.data.error ||
            I18n.getText(
              "settings.update-error",
              {},
              "Couldn't Update Preference"
            ),
          {
            type: "error",
            className: "errorClass"
          }
        );
      }
    } catch (error) {
      yield put(Actions.changeFbnSettingsFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }

  function* watchChangeFbnSettings(): Generator<void, void, void> {
    yield takeLatest(Types.CHANGE_FBN_SETTINGS, changeFbnSettings);
  }

  return {
    watchGetUser,
    watchGetSeller,
    watchLogout,
    watchAcceptTerms,
    watchGetTnC,
    watchGetWareHouses,
    watchGetUsersList,
    watchGetVatInfo,

    watchGetOfferCount,

    watchSyncInventory,

    watchGetNotification,
    watchReadNotification,

    watchGetNotificationPreference,
    watchPostPreference,

    watchGetFbnSettings,
    watchChangeFbnSettings
  };
};



// WEBPACK FOOTER //
// ./src/sagas/UserSaga.js